module.exports = __webpack_public_path__ + "esa24-39bef300.webp";